<template>
    <v-app>
        <v-form ref="form" @submit.prevent="validate" dense>
            <div class="md-layout">
                <div class="md-layout-item md-size-100 mx-auto">
                    <v-select v-model="form.taskMode" :items="taskModeList" item-text="name" item-value="value" label="任务模式"></v-select>
                    <v-text-field v-model="form.name" label="任务名称" hint="请输入任务名称"></v-text-field>
                </div>
            </div>
        </v-form>
    </v-app>
</template>
<script>
import { mapState } from 'vuex';
import { SlideYDownTransition } from 'vue2-transitions'
import { listCourse } from '@/api/course'
import { listProject } from '@/api/project'
import { listDeviceModelDefinition } from '@/api/modelDefinition/deviceModelDefinition'
import { listSceneModelDefinition } from '@/api/modelDefinition/sceneModelDefinition'

export default {
    components: {
        SlideYDownTransition
    },
    props: {
        avatar: {
            type: String,
            default: './img/default-avatar.png'
        }
    },
    // inject: ['taskInfo'],
    computed: {
        ...mapState(['global/taskInfo']),
        taskInfo() {
            return this.$store.state.global.taskInfo;
        }
    },
    data() {
        return {
            taskModeList: [
                { value: 'study', name: '学习' },
                { value: 'train', name: '练习' },
                { value: 'exam', name: '考核' }
            ],
            form: {
                isPublic: false
            },
            modList: [],
            sceneModList: [],
            courseList: [],
            projectList: [],
            projectDisabled: false
        }
    },
    watch: {
        'form.device'(val) {
            this.$emit('handleChoose', val)
        },
        'form.scene'(val) {
            this.$emit('handleSceneChoose', val)
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        async initForm(form) {
            Object.assign(this.form, form)
        },
        async filterProject(item) {
            const projectResult = await listProject({
                course: item._id,
                perPage: 500
            })
            if (projectResult.code == 200) {
                this.projectList = projectResult.data.rows
                this.projectDisabled = false
            }
        },
        async filterScene() {
            const { course, project } = this.form
            const result = await listDeviceModelDefinition({
                perPage: 100,
                course,
                project
            })

            const { code, data } = result

            if (code == 200) {
                this.modList = data.rows
            }

        },
        async init() {
            const courseResult = await listCourse({ perPage: 1000, })
            const projectResult = await listProject({ perPage: 1000, })
            const modResult = await listDeviceModelDefinition({ perPage: 1000, })
            const sceneModResult = await listSceneModelDefinition({ perPage: 1000, })
            if (courseResult.code == 200) {
                this.courseList = courseResult.data.rows
            }
            if (projectResult.code == 200) {
                this.projectList = projectResult.data.rows
            }
            if (modResult.code == 200) {
                this.modList = modResult.data.rows
            }
            if (sceneModResult.code == 200) {
                this.sceneModList = sceneModResult.data.rows
            }
            if (this.$route.query._id) {
                this.form = this.taskInfo
                this.projectDisabled = false
            }
        },
        handlePreview(file) {
            this.model.imageUrl = URL.createObjectURL(file.raw)
        },
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files
            if (!files.length) return
            this.createImage(files[0])
        },
        validate() {
            if (this.$refs.form.validate()) {
                this.$emit("on-validated", true);
                return true;
            }
        },
        createImage(file) {
            var reader = new FileReader()
            var vm = this

            reader.onload = (e) => {
                vm.image = e.target.result
            }
            reader.readAsDataURL(file)
        }
    }
}
</script>
<style></style>
